export function resizeImageFile(
  file,
  {
    maxSize = 1600,
    quality = 0.9,
    fileName = file.name.replace(/\.\w+$/, ".jpg"),
  } = {}
) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    const url = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement("canvas");

      let { width, height } = img;

      if (width > height && width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }

      if (height > width && height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }

      canvas.width = Math.round(width);
      canvas.height = Math.round(height);

      const ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(url);

          if (!blob) {
            reject(new Error("Error al comprimir imagen"));
            return;
          }

          const resizedFile = new File(
            [blob],
            fileName,
            {
              type: "image/jpeg",
            }
          );

          resolve(resizedFile);
        },
        "image/jpeg",
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("No se pudo leer la imagen"));
    };

    img.src = url;
  });
}
